import { __assign, __read, __rest, __spread } from "tslib";
import React from "react";
import classNames from "classnames";
import { Tooltip } from "../../tooltip";
export function rowtooltip(options) {
    return {
        getInfo: function () { return ({ name: "rowtooltip" }); },
        onInjectRow: function (next) { return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var result = next.apply(void 0, __spread(args));
            // 对于提供了 tooltip 的，用 tooltip 包裹
            var _a = __read(args, 1), record = _a[0];
            var tooltip = options.tooltip(record);
            if (tooltip) {
                result.row = (React.createElement(TooltipWrapper, { key: result.row.key, tooltip: tooltip }, result.row));
            }
            return result;
        }; },
    };
}
function TooltipWrapper(_a) {
    var children = _a.children, tooltip = _a.tooltip, props = __rest(_a, ["children", "tooltip"]);
    return (React.createElement(Tooltip, { title: tooltip }, React.cloneElement(React.Children.only(children), __assign(__assign({}, props), { 
        // eslint-disable-next-line react/destructuring-assignment
        className: classNames(props.className, children.props.className) }))));
}
//# sourceMappingURL=rowtooltip.js.map